/* eslint-disable import/prefer-default-export */

import { createContext } from 'react';
import type { ProductTabType } from 'autogen/swagger/all';

export const ProductAccordionContext = createContext<(activeType: ProductTabType) => void>(() => null);
